module.exports = __webpack_public_path__ + "static/img/carousel_3_optyeh_ar_4_3_w_1534.c93ccc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_3_optyeh_ar_4_3_w_1534.jpg
// module id = g+tg
// module chunks = 0